import React, { useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { Icon } from "@iconify/react";
import { useSelector, useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import GlobalDialog from "../../../../../mui/Dialogue/GlobalDialog";
import {
    ApproveButton,
    CancelButton,
} from "../../../../../mui/Buttons/Buttons";
import {
    AllStudentsByCroId,
    createStudent,
} from "../../../../../../redux/features/croSlice";

export const CreateStudent = ({ params }) => {
    const dispatch = useDispatch();
    const [open, setOpen] = useState(false);
    const { loading } = useSelector((state) => state.cro);
    const { enqueueSnackbar } = useSnackbar();
    const profile = JSON.parse(localStorage.getItem("cred")).profile;

    const handleSubmit = () => {
        const data = {
            vendorUserId: `${params.admn_no}`,
            name: params.name,
            email: params.email,
            profile: "student",
            phoneNumber: `+91${params.student_mob_no}`,
            rollId: profile.roleID,
        };
        dispatch(createStudent(data)).then((res) => {
            if (res.payload.status === "error") {
                setOpen(false);
                enqueueSnackbar(res.payload.message, { variant: "error" });
            } else if (res.payload.status === "success") {
                setOpen(false);
                dispatch(AllStudentsByCroId());
                enqueueSnackbar("Created successfully", {
                    variant: "success",
                });
            }
        });
    };
    return (
        <div>
            <GlobalDialog
                title="Create Student"
                open={open}
                setOpen={setOpen}
                fullWidth
                maxWidth={"xs"}
                popupButton={
                    <>
                        <Button
                            size="small"
                            sx={{ backgroundColor: "#2f72b34f" }}
                            onClick={() => setOpen(true)}
                        >
                            <Icon
                                icon="material-symbols-light:assignment-add-outline"
                                height={22}
                                width={22}
                            />
                            Create
                        </Button>
                    </>
                }
                content={
                    <>
                        <Box>
                            <Box>
                                <Typography variant="sub-title">
                                    Are you sure. You want to Create
                                    {params.name}..?
                                </Typography>
                            </Box>
                        </Box>
                    </>
                }
                actionButton={
                    <>
                        <CancelButton
                            size="small"
                            action={() => setOpen(false)}
                        >
                            Cancel
                        </CancelButton>
                        <ApproveButton size="small" action={handleSubmit}>
                            {loading ? "Creating..." : "Create"}
                        </ApproveButton>
                    </>
                }
            />
        </div>
    );
};
